import {
  createContext,
  useContext,
  useState,
  useEffect,
  ReactElement,
  Dispatch,
  SetStateAction,
} from 'react';
import { GameMedia } from 'functions/src/types/firestore/Game/GameMedia';
import { useRouter } from 'next/router';

type MediaContextType = {
  media: GameMedia[];
  activeMediaIndex: number;
  setActiveMediaIndex: Dispatch<SetStateAction<number>>;
};

const MediaContext = createContext<MediaContextType>({
  media: null as unknown as GameMedia[],
  activeMediaIndex: 0,
  setActiveMediaIndex: () => {
    /** */
  },
});

export type MediaProviderProps = {
  children: ReactElement;
  media: GameMedia[];
};

export const MediaProvider = ({ children, media }: MediaProviderProps) => {
  const router = useRouter();
  const { media: queryMedia } = router.query;
  const [activeMediaIndex, setActiveMediaIndex] = useState<number>(0);
  const [hasAppliedQuery, setAppliedQuery] = useState(false);

  useEffect(() => {
    if (!router?.isReady) {
      return;
    }
    if (!hasAppliedQuery && queryMedia) {
      setActiveMediaIndex(
        Math.max(
          mediaSorted.findIndex((gameMedium) => {
            return gameMedium.src === queryMedia;
          }),
          0,
        ),
      );
      setAppliedQuery(true);
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [media, router?.isReady]);

  const mediaSorted = media.sort((mediaA, mediaB) => {
    return (
      (mediaB['viewerCount'] || 0) - (mediaA['viewerCount'] || 0) ||
      mediaA['priority'] - mediaB['priority']
    );
  });

  return (
    <MediaContext.Provider
      value={{
        media: mediaSorted,
        activeMediaIndex,
        setActiveMediaIndex,
      }}
    >
      {children}
    </MediaContext.Provider>
  );
};

export const useMedia = () => {
  return useContext(MediaContext);
};
